import budgetSourceLogo from '../assets/logos/Budget-Source.svg';
import essentialsForHomeLogo from '../assets/logos/efh-logo.svg';
import funSourceLogo from '../assets/logos/funsource.png';
import gccLogo from '../assets/logos/gcc.png';
import homePlayLogo from '../assets/logos/Homeplay_Logo.png';
import pulseLogo from '../assets/logos/pulse.png';
import rizzbatesLogo from '../assets/logos/rizzbates.png';
import savingsCentralLogo from '../assets/logos/savingscentral.png';
import tasteForSavingsLogo from '../assets/logos/tasteForSavings.png';
import valueAccessLogo from '../assets/logos/value_access.svg';
import valuePlusLogo from '../assets/logos/valueplus.png';

export const membershipInfoList = {
	valueplusonline: {
		name: 'Value Plus',
		clubCategory: 38,
		website: 'valueplusonline.com',
		contactEmail: 'membership@valueplusonline.com',
		logo: valuePlusLogo,
		blurb: 'Life’s Expensive. Live Better with Value Plus!'
	},
	myvalueaccess: {
		name: 'Value Access',
		clubCategory: 70,
		website: 'myvalueaccess.com',
		logo: valueAccessLogo, // @TODO: Add Logo
		blurb: '[TEST COPY] - Value Access' // @TODO: Add Blurb
	},
	homeplay: {
		name: 'Home Play',
		clubCategory: 32,
		website: 'homeplayonline.com',
		logo: homePlayLogo,
		blurb:
			'With HomePlay, fun is always in the budget-score sweet deals and rebates on everything from bowling nights out to board game battles at home!'
	},
	essentialsforhome: {
		name: 'Essentials for Home',
		clubCategory: 42,
		website: 'essentialsforhome.com',
		logo: essentialsForHomeLogo,
		blurb:
			'Your inside pass to discounted gift cards, cash back rebates, and exclusive home improvement deals to turn your DIY, fixer-upper dreams into reality.'
	},
	budgetsource: {
		name: 'Budget Source',
		clubCategory: 57,
		website: 'mybudgetsource.com',
		logo: budgetSourceLogo,
		blurb:
			'Access a wide variety of coupons, local discounts, and cashback offers with Budget Source.'
	},
	tasteforsavings: {
		name: 'Taste for Savings',
		clubCategory: 65,
		website: 'tasteforsavings.com',
		logo: tasteForSavingsLogo,
		blurb:
			'Enjoy discounts at your favorite restaurants and save on dining with Taste for Savings.'
	},
	savingscentral: {
		name: 'Savings Central',
		clubCategory: 74,
		website: 'isavingscentral.com',
		logo: savingsCentralLogo,
		blurb:
			'Your one-stop-shop for every-day savings: get access to discounted gift cards, cash-back rebates, and everyday deals on household essentials with Savings Central.'
	},
	rizzbates: {
		name: 'Rizzbates',
		clubCategory: 120,
		website: 'rizzbates.com',
		logo: rizzbatesLogo,
		blurb:
			'Your one-stop-shop for every-day savings: get access to discounted gift cards, cash-back rebates, and everyday deals on household essentials with Savings Central.'
	},
	pulse: {
		name: 'Pulse',
		clubCategory: 51,
		website: 'mypulseonline.com',
		logo: pulseLogo,
		blurb:
			'Your one-stop-shop for every-day savings: get access to discounted gift cards, cash-back rebates, and everyday deals on household essentials with Savings Central.'
	},
	gcc: {
		name: 'GCC',
		clubCategory: 108,
		website: 'mygiftcardconnection.com',
		logo: gccLogo,
		blurb:
			'Your one-stop-shop for every-day savings: get access to discounted gift cards, cash-back rebates, and everyday deals on household essentials with Savings Central.'
	},
	funsource: {
		name: 'FunSource',
		clubCategory: 49,
		website: 'myfunsource.com',
		logo: funSourceLogo,
		blurb:
			'Your one-stop-shop for every-day savings: get access to discounted gift cards, cash-back rebates, and everyday deals on household essentials with Savings Central.'
	},
	localhost: {
		name: 'Savings Central',
		logo: savingsCentralLogo,
		blurb:
			'Your one-stop-shop for every-day savings: get access to discounted gift cards, cash-back rebates, and everyday deals on household essentials with Savings Central.'
	}
};
